import React, { useEffect, useState } from "react";
import { ColorTheme, COLOR_THEMES } from "lib/models";

type ThemeColors = {
  [varName: string]: string;
};

const COLOR_VARS: string[] = [
  "--color-1",
  "--color-2",
  "--color-3",
  "--color-4",
  "--color-5",
];

function getThemeColors(theme: ColorTheme): ThemeColors {
  // Apply the theme to a hidden element so load the color options
  const tempEl: HTMLElement = document.createElement("div");
  tempEl.setAttribute("data-theme", theme);
  tempEl.style.position = "absolute";
  tempEl.style.top = "-9999px";
  document.body.appendChild(tempEl);

  const computedStyles: CSSStyleDeclaration = window.getComputedStyle(tempEl);
  const colors: ThemeColors = {};
  for (const color of COLOR_VARS) {
    const colorValue = computedStyles.getPropertyValue(color).trim();
    colors[color] = colorValue;
  }

  document.body.removeChild(tempEl);
  return colors;
}

interface PaletteProps {
  theme: ColorTheme;
  hideLabel?: boolean;
}

const ColorPalette = ({ theme, hideLabel }: PaletteProps) => {
  const [themePalettes, setThemePalettes] = useState<
    Record<ColorTheme, ThemeColors>
  >({});

  useEffect(() => {
    const palettes: Record<string, ThemeColors> = {};
    for (const themeName of COLOR_THEMES) {
      palettes[themeName] = getThemeColors(themeName);
    }
    setThemePalettes(palettes);
  }, []);

  return (
    <div key={theme} className="mb-2 w-full">
      {!hideLabel ? <h3 className="capitalize">{theme}</h3> : null}
      <div className="flex flex-row justify-center">
        {COLOR_VARS.map((color: string) => {
          return (
            <div
              key={`colorPalette:${theme}:${color}`}
              style={{
                backgroundColor: themePalettes[theme]?.[color] || "#ffffff",
                width: "50px",
                height: "50px",
                border: "1px solid #ccc",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ColorPalette;
